import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { SetupWizardEngagementStatus } from '@principle-theorem/principle-core';

const ENGAGEMENT_LABELS: Record<SetupWizardEngagementStatus, string> = {
  [SetupWizardEngagementStatus.Active]: 'Active',
  [SetupWizardEngagementStatus.Slowing]: 'Slowing',
  [SetupWizardEngagementStatus.Disengaged]: 'Disengaged',
  [SetupWizardEngagementStatus.NeverEngaged]: 'Never Engaged',
  [SetupWizardEngagementStatus.NoData]: 'No Data',
};

@Component({
  selector: 'pr-engagement-pill',
  templateUrl: './engagement-pill.component.html',
  styleUrls: ['./engagement-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  host: { class: 'inline-flex' },
})
export class EngagementPillComponent {
  state = input.required<SetupWizardEngagementStatus>();
  label = computed(() => ENGAGEMENT_LABELS[this.state()]);
  readonly EngagementState = SetupWizardEngagementStatus;
}
